import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Confirm, Divider, Icon, Input, Segment, Menu, MenuItem, Sticky } from "semantic-ui-react";
import ReactTable from "react-table";

import request from "../../utils/request";
import matchSorter from 'match-sorter';

const sellerTabs = {
  activeSellers: 1,
  archivedSellers: 2
}

class SellerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      sorted: [{ id: "login", desc: false }],
      data: [],
      query: "",
      pageSize: 20,
      page: 0,
      pages: -1,
      resized: [],
      filtered: [],
      activeItem: sellerTabs.activeSellers
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  fetchData = () => {
    this.setState({ isLoading: true });

    const params = {
        sort: this.state.sorted,
        q: this.state.query,
        page: this.state.page + 1,
        limit: 0,
        filter_volunteers: this.state.activeItem,
        ts: Date.now()
    }

    request
      .list(this, "api:/volunteer-real", params)
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          pages: Math.ceil(resp.total / this.state.pageSize)
        });
      });
  };
  showConfirm = (id, title) => {
    this.setState({ confirmOpen: true, confirmId: id, confirmTitle: title });
  };
  cancelConfirm = () => {
    this.setState({ confirmOpen: false, confirmId: 0, confirmTitle: '' });
  }
  handleConfirm = () => {
    if (this.state.activeItem == 1) {
      this.deleteSeller();
    } else {
      this.restoreSeller();
    }
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.fetchData();
    }
  };
  handleSearch = e => {
    this.setState({ page: 1 });
    setTimeout(this.fetchData, 200);
  };
  restoreSeller = () => {
    let payload = {
        volunteer_id: this.state.confirmId
    };
    this.setState({
      isLoading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.post(this, "api:/volunteer/restore", payload).then(resp => {
      this.setState({
        isLoading: false
      });
      return this.fetchData();
    });
  };
  deleteSeller = () => {
    this.setState({
      isLoading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.delete(this, `api:/volunteer/${this.state.confirmId}`).then(resp => {
      this.setState({
        isLoading: false
      });
      return this.fetchData();
    });
  };
  handleSellersMenuClick = (e, activeTab) => {
    this.setState({ activeItem: activeTab }, () => {
      this.fetchData();
    })
  };
  render() {
    const {
      data,
      isLoading,
      confirmOpen,
      confirmTitle,
      activeItem
    } = this.state;
    const columns = [
      {
        Header: "Action",
        id: "id",
        accessor: d => (
          <div>
            <Button
              as={Link}
              to={`/sellers/${d.id}/edit`}
              primary
              icon="edit"
            />
            {activeItem == 1 && <Button
              color="red"
              type="button"
              onClick={() => this.showConfirm(d.id, `Are you sure your want to delete ${d.first_name} ${d.last_name} (${d.login})?`)}
              icon="trash"
            />}
            {activeItem == 2 && <Button
              color="green"
              type="button"
              onClick={() => this.showConfirm(d.id, `Are you sure your want to restore ${d.first_name} ${d.last_name} (${d.login})?`)}
              icon="undo"
            />}
          </div>
        ),
        filterable: false
      },
      {
        Header: "Login",
        accessor: "login",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["login"] }),
        filterAll: true

      },
      {
        Header: "Name",
        id: "last_name",
        accessor: d => d.first_name + " " + d.last_name,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["last_name"] }),
        filterAll: true
      },
      {
        Header: "Email",
        accessor: "email",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["email"] }),
        filterAll: true
      },
      {
        Header: "Phone",
        accessor: "phone_number",
        filterable: false
      }
    ];
    return (
      <Segment basic className="SellerListSegment">
        <Confirm
          open={confirmOpen}
          content={confirmTitle}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={this.cancelConfirm}
          onConfirm={this.handleConfirm}
        />
        <Menu secondary stackable>
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                as={Link}
                to={"/Sellers/create"}
                icon="add user"
                content="New Seller"
                primary
                fluid
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <Sticky>
          <Menu color='orange' pointing stackable>
            <MenuItem name="activeSellers" active={activeItem == sellerTabs.activeSellers} onClick={(e) => { this.handleSellersMenuClick(e, sellerTabs.activeSellers) }}>
              <Icon name='calendar check' color='green' />
              Active Sellers
            </MenuItem>
            <MenuItem name="archivedSellers" active={activeItem == sellerTabs.archivedSellers} onClick={(e) => { this.handleSellersMenuClick(e, sellerTabs.archivedSellers) }}>
              <Icon color='red' name='archive' />
              Archived Sellers
            </MenuItem>
          </Menu>
        </Sticky>
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          resizable
          filterable
          defaultPageSize={20}
          defaultSorted={[{ id: "name", desc: false }]}
          minRows={0}
        />
      </Segment>
    );
  }
}

export default SellerList;
